import localFont from 'next/font/local'

export const optima = localFont({
  src: [
    {
      path: './fonts/Optima.woff2',
      weight: '400',
      style: 'normal'
    },
    {
      path: './fonts/Optima-Bold.woff2',
      weight: '500',
      style: 'normal'
    }
  ]
})

export type ThemeProps = { altBackground?: boolean }

const Theme = ({ altBackground }: ThemeProps) => {
  return (
    <style jsx global>
      {`
        :root {
          --font-family-optima: ${optima.style.fontFamily};
          --font-family-proxima: 'proxima-nova';

          --gutter: 1rem;

          --background-primary: ${altBackground ? '#e0e5d0' : '#dee1db'};
        }

        @media (min-width: 768px) {
          :root {
            --gutter: 3rem;
          }
        }
      `}
    </style>
  )
}

export default Theme
